import Address from './address';

export default function SepaPaymentMethod(data){
    let paymentMethod = data || {};
    this.id = paymentMethod.id;
    this.type = "Sepa";
    this.bankCode = paymentMethod.bankCode;
    this.branchCode = paymentMethod.branchCode;
    this.iban = paymentMethod.iban;
    this.country = paymentMethod.country;
    this.email = paymentMethod.email;
    this.name = paymentMethod.name;
    this.phone = paymentMethod.phone;
    this.isDefault = paymentMethod.isDefault;
    this.address = paymentMethod.address !== undefined ? new Address(paymentMethod.address) : undefined;
}